import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  pageUserAddresses, 
  deleteUserAddress, 
  setDefaultAddress
} from '../../api/userAddress';
import { message } from 'antd';

// 分页查询用户地址列表的异步 thunk
export const fetchAddressList = createAsyncThunk(
  'userAddress/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await pageUserAddresses(params);
      return response.data;
    } catch (error) {
      message.error('获取用户地址列表失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 删除用户地址的异步 thunk
export const deleteUserAddressAction = createAsyncThunk(
  'userAddress/delete',
  async (addressId, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteUserAddress(addressId);

      if (response.code === 200) {
        message.success('删除用户地址成功');
        // 重新获取列表
        dispatch(fetchAddressList());
        return response.data;
      } else {
        message.error(response.message || '删除失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('删除用户地址请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 设置默认地址的异步 thunk
export const setDefaultAddressAction = createAsyncThunk(
  'userAddress/setDefault',
  async ({ addressId, userId }, { dispatch, rejectWithValue }) => {
    try {
      const response = await setDefaultAddress(addressId, userId);

      if (response.code === 200) {
        message.success('设置默认地址成功');
        // 重新获取列表
        dispatch(fetchAddressList());
        return response.data;
      } else {
        message.error(response.message || '设置默认地址失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('设置默认地址请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

const userAddressSlice = createSlice({
  name: 'userAddress',
  initialState: {
    addressList: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // 获取地址列表
      .addCase(fetchAddressList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAddressList.fulfilled, (state, action) => {
        state.loading = false;
        state.addressList = action.payload.records;
        state.total = action.payload.total;
        state.page = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchAddressList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 删除用户地址
      .addCase(deleteUserAddressAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUserAddressAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteUserAddressAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 设置默认地址
      .addCase(setDefaultAddressAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(setDefaultAddressAction.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(setDefaultAddressAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const {
  setPage,
  setPageSize
} = userAddressSlice.actions;

export default userAddressSlice.reducer; 